import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';


export interface IActivateSiteEncryptionKeyParams {
  externalKeyId: string;
}

export interface ActivateSiteEncryptionKeyResult extends IResult {}

export class ActivateSiteEncryptionKeyRequest extends Request<IActivateSiteEncryptionKeyParams, ActivateSiteEncryptionKeyResult> {
  constructor(params: IActivateSiteEncryptionKeyParams) {
    super('activateSiteEncryptionKey', params);
  }
}